export const navLinkHeight = {
	height: '2.25rem',
	lineHeight: '2.25rem',
};
export const underlineStyles = {
	padding: '0 1rem',
	'&::after': {
		content: '""',
		display: 'block',
		height: '0.125rem',
		width: 0,
		backgroundColor: 'transparent',
		transition: 'width .3s ease, background-color .3s ease',
		position: 'relative',
		top: '0px',
	},
	':hover::after': {
		width: '100%',
		backgroundColor: 'tertiary.main',
	},
	'&.active::after': {
		width: '100%',
		backgroundColor: 'tertiary.main',
	},
};

export const mobileNavTopItemStyles = {
	padding: { xs: '0 .25rem', md: '0 1.25rem' },

	'.MuiTypography-root': {
		height: 'auto',
		border: 'none',
		backgroundColor: 'none',
	},
};

export const mobileNavItemStyles = {
	padding: '1rem 1.25rem',
	display: 'flex',
	flexFlow: 'row wrap',
	justifyContent: 'left',
	alignItems: 'center',

	'.MuiTypography-root': {
		border: 'none',
		height: 'auto',
		textIndent: 0,
	},
};

// Cancels NavigationLink's built-in mobile utility sizing (lineHeight/width, meant for a
// different utility nav bar) so top-level links match the group header's natural text spacing.
export const mobileNavLinkTypographyResetStyles = {
	'.MuiTypography-root': {
		border: 'none',
		height: 'auto',
		textIndent: 0,
		lineHeight: 'normal',
		width: 'auto',
	},
};

export const getNavItemStyles = (linkColor?: string, fontWeight?: string | number) => ({
	...underlineStyles,
	'.MuiTypography-root': {
		padding: '0 0.5rem',
		color: linkColor ?? 'text.primary',
		fontWeight: fontWeight ?? 600,
		height: 'inherit',
		lineHeight: 'inherit',

		'&::after': {
			content: '""',
			display: 'none',
		},
	},
});

export const navItemWithIconStyles = {
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
	display: 'inline-block', // makes the link 100% height so that user doesn't have to click exactly on the text
	fontSize: '1rem',
	fontWeight: 600,
	padding: '0 0.5rem',
	...navLinkHeight,
};

export const dropMenuStyles = {
	'.MuiPaper-root': {
		backgroundColor: 'neutrals.white',
		boxShadow: 'none',
		borderRadius: '0 0 0.5rem 0.5rem',
		'.MuiList-root': {
			'.MuiMenuItem-root': {
				a: {
					width: '100%',
					span: {
						padding: '0 0.5rem',
					},
				},
			},
		},
	},
};

export const navGroupLinkStyles = {
	groupLinkStyles: {
		color: 'text.interactive',
		'&:last-of-type': {
			paddingRight: '0',
		},
	},
	groupLinkTitleStyles: {
		'&.MuiTypography-root': {
			':hover::after': {
				width: 'calc(100% - 0.375rem)',
			},
		},
	},
	getGroupLinkIconStyles: (active: boolean) => ({
		verticalAlign: 'middle',
		mb: '0.2rem',
		ml: '0.2rem',
		transition: 'transform 0.2s ease-in-out',
		...(active && {
			transform: 'rotate(-180deg)',
		}),
	}),
	// TAGSvgIcon discards its own sx, so this is applied to the Typography wrapping it instead; starts pointing right, rotates to point down when open.
	getMobileGroupLinkIconStyles: (active: boolean) => ({
		display: 'inline-flex',
		verticalAlign: 'middle',
		ml: '0.25rem',
		transition: 'transform 0.2s ease-in-out',
		...(active && {
			transform: 'rotate(90deg)',
		}),
	}),
};

export const collapseMenuItemStyles = {
	'.MuiCollapse-wrapperInner': {
		display: 'flex',
		flexDirection: 'column',
		// Matches GroupNavList's mobile sub-nav column gap (SubNavColumnRender)
		gap: '0.5rem',
	},
};
